import { FeatureFlags, useFeatureFlag } from '~/utils/featureflags';

export const useIsPrintDetectionEnabled = (): boolean =>
  useFeatureFlag(FeatureFlags.QUICKPACK_SHIPPO_PRINT_DETECTION)?.enabled ?? false;
